// Extracted from src/api/scribeAPIV2.ts — history: git log --follow src/api/scribeAPIV2.ts.
import type { components } from '@heidi/schema/ml-scribe';

import { http } from './ehrHttp';

/** @domain integrations */
export const getUserEHR = () => {
  return http().get<components['schemas']['EHRProfileResponse']>('/user/ehr-profile');
};

/** @domain integrations */
export const connectIntegration = (
  payload: components['schemas']['CreateEHRProfileAPIRequest']
) => {
  return http().post<components['schemas']['EHRProfileResponse']>(
    '/user/ehr-profile',
    payload
  );
};

/** @domain integrations */
export const deleteIntegration = () => {
  return http().delete(`/user/ehr-profile`);
};
